/**
 * Author: David
 *
 * Thanks to: Garaje de Ideas. https://www.youtube.com/watch?v=76pYx_ND_zo 
 * Draggable Ondragstart Ondrag Ondragend Ondragenter Ondragover Ondragleave Ondrop
 * 
 * Composables: https://vuejs.org/guide/reusability/composables.html
 * 
 * 
 * USO:
 * 
 * import { useDraggable } from '../../composables/draggable.js'
 * const { draggedItem, dragOverItem, handleDragStart, handleDragOver, handleDrop, handleDragEnd } = useDraggable();
 * 
 * function handleDrop(index) {
 *  const droppedItem = testStore.dimensiones.splice(draggedItem.value, 1)[0]
 *  testStore.dimensiones.splice(index, 0, droppedItem)
 *  handleDragReset();
 * }
 * 
 * 
 * 
 * 
 */

import {ref} from 'vue'

export function useDraggable() {

  const draggedItem = ref(null);
  const dragOverItem = ref(null);


  function handleDragStart(index) {
    draggedItem.value = index;
  }

  // Me permite que funcione sin problemas el drag.
  function handleDragOver(event, index) {
    event.preventDefault();
    dragOverItem.value = index;
  }

  function handleDragReset() {
    draggedItem.value = null;
    dragOverItem.value = null;
  }

  function handleDragEnd() {
    draggedItem.value = null;
    dragOverItem.value = null;
  }

  return { draggedItem, dragOverItem, handleDragStart, handleDragOver, handleDragReset, handleDragEnd }
}